import wNumb from 'wnumb';
import { W8ShippingAPIClient } from './W8_ShippingAPIClient';

const theme = window.theme;

export function lazyLoadGalleryLot() {
  const thumbElements = document.querySelectorAll(
    '#lot-gallery-thumb .swiper-slide img',
  );
  const firstFourElements = Array.from(thumbElements).slice(0, 4);
  const lazyImages = Array.from(document.querySelectorAll('[data-lazy-src]'));
  lazyImages.unshift(...firstFourElements);
  const firstImage = document.querySelector('.swiper-auction-car-gallery img');
  const zoomContainer = document.querySelector('.js-image-zoom__zoomed-image');
  const set = new Set(lazyImages.map((el) => el.dataset.lazySrc));
  const event = new CustomEvent('lazy-images-loaded', {
    detail: { loadedImages: lazyImages },
  });
  const queue = Array.from(set); // Черга зображень для завантаження
  const maxConcurrentLoads = 1; // Обмежуємо кількість одночасних завантажень
  let activeLoads = 0;
  let totalToLoad = queue.length;
  let loadedCount = 0;

  function loadNextImage() {
    if (activeLoads >= maxConcurrentLoads || queue.length === 0) return;

    activeLoads++;
    const src = queue.shift(); // Беремо перший елемент із черги
    const img = new Image();
    img.src = src;

    img.onload = () => {
      document.querySelectorAll(`[data-lazy-src="${src}"]`)?.forEach((el) => {
        el.src = img.src;
        if (el.previousElementSibling) {
          el.previousElementSibling.remove();
          el.classList.remove('animate-pulse');
          el.classList.add('lazy-replaced');
          if (el === firstImage && zoomContainer) {
            zoomContainer.style.backgroundImage = `url(${img.src})`;
          }
        }
      });

      activeLoads--;
      loadedCount++;

      if (loadedCount === totalToLoad) {
        document.dispatchEvent(event);
      } else {
        loadNextImage(); // Завантажуємо наступне зображення
      }
    };

    img.onerror = () => {
      console.error(`Failed to load image: ${src}`);
      activeLoads--;
      loadedCount++;
      if (loadedCount === totalToLoad) {
        document.dispatchEvent(event);
      } else {
        loadNextImage(); // Продовжуємо чергу, навіть якщо була помилка
      }
    };
  }

  // Запускаємо одночасно до maxConcurrentLoads завантажень
  for (let i = 0; i < maxConcurrentLoads; i++) {
    loadNextImage();
  }
}

export function sendEventDataToGA4(event, data = {}) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: event,
    ...data,
  });
}

export const screens = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const changeAuctionsOptions = () => {
  const auction =
    document.querySelector('input[name="auction"]:checked') ??
    document.getElementById('auction');
  const auctionCity = document.getElementById('auctionCity');

  if (!auctionCity || !auction) return;

  if (!document.calcSettings) {
    setTimeout(changeAuctionsOptions, 1000);
    return;
  }

  const deafaultOption = auctionCity.querySelector('option');
  auctionCity.innerHTML = '';
  auctionCity.tomselect.clear();
  auctionCity.tomselect.clearOptions();
  auctionCity.append(deafaultOption);
  const auctionData = document.calcSettings.auctions.find(
    (el) => el.name == auction.value,
  );

  if (auctionData) {
    auctionData.price.forEach((element) => {
      let option = document.createElement('option');
      option.setAttribute('value', element.price);
      option.dataset.port = element.port;
      option.innerHTML = element.city;
      option.value = element.city;
      auctionCity.insertAdjacentElement('beforeend', option);
    });

    auctionCity.removeAttribute('disabled');
    auctionCity.closest('.input').classList.remove('disabled');

    if (auctionCity.tomselect) {
      auctionCity.tomselect.sync();
      auctionCity.tomselect.enable();
    }
  } else {
    auctionCity.setAttribute('disabled', 'true');
    auctionCity.closest('.input').classList.add('disabled');

    if (auctionCity.tomselect) {
      auctionCity.tomselect.disable();
    }
  }
};

export function getPortByAuctionAndCity(auction, city) {
  const auctionData = document.calcSettings.auctions.find(
    (el) => el.id === auction,
  );

  if (!auctionData) {
    console.error(`Auction ${auction} not found`);
    return null;
  }

  const cityData = auctionData.price.find((el) => el.city === city);

  if (!cityData) {
    console.error(`City ${city} in ${auction} not found`);
    return null;
  }

  return cityData.port;
}

export const changeAuctionCity = () => {
  const auctionCity = document.getElementById('auctionCity');
  const portTo = document.getElementById('portTo');
  const vehicleType = document.getElementById('vehicleType');

  if (!document.calcSettings) {
    setTimeout(changeAuctionCity, 1000);
    return;
  }

  // if (!auctionCity || !portTo || !vehicleType) return;

  const portCurrent =
    auctionCity.options[auctionCity.selectedIndex].dataset.port;
  if (!portCurrent) {
    return;
  }

  const values = [portCurrent, vehicleType.value];

  for (let index = 0; index < values.length; index++) {
    if (values[index] == '') {
      return;
    }
  }

  if (portTo) {
    Array.prototype.forEach.call(portTo.options, (option) => {
      if (!option.value) {
        return;
      }

      const price = document.calcSettings.seaShippingPrice.find(
        (el) =>
          el.port === option.value && el.vehicle_type === vehicleType.value,
      )[`port_${portCurrent}`];

      if (price === null) {
        option.setAttribute('disabled', 'true');
      } else {
        option.removeAttribute('disabled');
      }
    });

    portTo.tomselect.clear();
    portTo.tomselect.clearOptions();
    portTo.tomselect.sync();
  }
};

export function changeEngineType(event) {
  const input = document.getElementById('engineVolume');
  if (!input) {
    return;
  }
  const placeholderElectro = input.dataset.labelElectro;
  const placeholderDefault = input.dataset.labelDefault;
  if (event.target.value == 'electric') {
    document.querySelector('label[for=engineVolume]').innerHTML =
      placeholderElectro;
    input.placeholder = placeholderElectro;
  } else {
    document.querySelector('label[for=engineVolume]').innerHTML =
      placeholderDefault;
    input.placeholder = placeholderDefault;
  }
}

function getSelectedAuction() {
  const selectedAuction =
    document.querySelector('input[name="auction"]:checked') ??
    document.getElementById('auction');
  return selectedAuction ? selectedAuction.value : null;
}

export const changeAuctionsCity = () => {
  const auctionCity = document.getElementById('auctionCity');
  const portFrom = document.getElementById('portFrom');
  const port = getPortByAuctionAndCity(getSelectedAuction(), auctionCity.value);
  portFrom.value = port;
};

export function getCurrentScreenSize() {
  const width = window.innerWidth;

  if (width >= screens['2xl']) {
    return '2xl';
  } else if (width >= screens.xl) {
    return 'xl';
  } else if (width >= screens.lg) {
    return 'lg';
  } else if (width >= screens.md) {
    return 'md';
  } else if (width >= screens.sm) {
    return 'sm';
  } else {
    return 'xs'; // Якщо ширина менша за найменше визначене значення
  }
}

export const onShowMicroModal = (modal) => {
  try {
    window.burger.closeBurger();
  } catch {
    console.error('Error: window.burger.closeBurger()');
  }
  document
    .getElementById('body')
    ?.classList.add('modal-active', 'modal-active_' + modal.id);
  const form = modal.querySelector('form');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'modal_show',
    modal_name: modal.id,
  });

  if (!(form && form.id === 'modal-form-general')) {
    return false;
  }
  form
    .querySelectorAll('.SalesChannel')
    .forEach((el) => el.classList.remove('active'));
  const input = document.getElementById(`${form.id}-SalesChannel`);
  const defaulValue = input.value;
  const el = form.querySelector(`[data-sales-channel="${defaulValue}"]`);
  // add active to current element
  el?.classList.add('active');
};

export const onCloseMicroModal = (modal) => {
  const titleElement = document.getElementById(`${modal.id}-title`);
  if (titleElement) {
    titleElement.innerHTML = window.defaultModaLdata[modal.id].title;
  }

  const textElement = document.getElementById(`${modal.id}-text`);
  if (textElement) {
    textElement.innerHTML = window.defaultModaLdata[modal.id].text;
  }

  const btnElement = document.getElementById(`${modal.id}-btn`);
  if (btnElement) {
    btnElement.innerHTML = window.defaultModaLdata[modal.id].btn;
  }

  document
    .getElementById('body')
    ?.classList.remove('modal-active', 'modal-active_' + modal.id);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'modal_close',
    modal_name: modal.id,
  });
};

export const toggleLoader = (element) => {
  element.classList.toggle('loading');
};

export function refreshFragments(fragments) {
  for (let prop in fragments) {
    const cartFragment = document.getElementById(prop);
    if (!cartFragment) {
      continue;
    }
    cartFragment.innerHTML = '';
    cartFragment.insertAdjacentHTML('afterbegin', fragments[prop]);
  }
}

export const moneyFormat = wNumb({
  mark: '.',
  thousand: ' ',
  prefix: '$',
});

export const numbFormat = wNumb({
  mark: '.',
  thousand: ' ',
});

export function isJSONString(str) {
  try {
    return JSON.parse(str);
  } catch {
    return false;
  }
}

function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isSafari() {
  return (
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  );
}

export function isIOS_Safari() {
  return isIOS() && isSafari();
}

export function setGetLotInfoListener(
  changeAuctionsOptions,
  setModels = null,
  onChangeCalcType = null,
) {
  const client = new W8ShippingAPIClient(
    theme.api.endpointW8,
    theme.api.nonce,
    theme.i18n.locale_pll,
  );
  document.getElementById('getLotInfo').addEventListener('click', async (e) => {
    client.post('getLotInfoByURL', {
      body: {
        lot_url: document.getElementById('lotUrl').value,
      },
      loadingElements: [e.target],
      onSuccess: ({ transformed }) => {
        const errorElement = document.getElementById('getLotInfoError');
        errorElement.innerHTML = '';
        errorElement.classList.add('hidden');

        const {
          costOfTheCar,
          auction,
          auctionCity,
          engineType,
          // vehicleType,
          engineVolume,
          graduationYear,
          customsMark,
          customsModel,
        } = transformed;

        // set auction
        const inputAuction = document.getElementById('auction');
        if (inputAuction) {
          if (inputAuction.tagName == 'SELECT' && inputAuction.tomselect) {
            document.getElementById('auction').tomselect.setValue(auction);
          } else {
            document.getElementById('auction-' + auction).checked = true;
          }
        }

        // set auction city
        changeAuctionsOptions();
        if (auctionCity) {
          document
            .getElementById('auctionCity')
            ?.tomselect.setValue(auctionCity);
        } else {
          document.getElementById('auctionCity')?.tomselect.clear();
          document
            .getElementById('auctionCity')
            ?.closest('.input')
            ?.classList.add('animated', 'shakeX');
        }

        // set port cost auto
        if (costOfTheCar && document.getElementById('costOfTheCar')) {
          document.getElementById('costOfTheCar').mask.unmaskedValue =
            new String(costOfTheCar);
        } else {
          document.getElementById('costOfTheCar').mask.unmaskedValue = '';
        }

        // set engine type
        if (engineType) {
          document.getElementById('engineType')?.tomselect.setValue(engineType);
        } else {
          document.getElementById('engineType')?.tomselect.clear();
        }

        // set vehicle type
        // if (vehicleType) {
        // 	document.getElementById("vehicleType")?.tomselect.setValue(vehicleType);
        // } else {
        // 	document.getElementById("vehicleType")?.tomselect.clear();
        // }

        // set engine volume
        if (document.getElementById('engineVolume')) {
          if (engineVolume) {
            document.getElementById('engineVolume').mask.unmaskedValue =
              new String(engineVolume);
          } else {
            document.getElementById('engineVolume').mask.unmaskedValue = '';
          }
        }

        // set graduation year
        const graduationYearSelect = document.getElementById('graduationYear');
        if (graduationYear && graduationYearSelect) {
          // if tomselect has value set it
          // else set minimum graduation year
          const graduationYearOptions = Array.from(
            graduationYearSelect.options,
          );
          const graduationYearValues = graduationYearOptions
            .map((option) => +option.value)
            .filter((value) => value)
            .sort();

          if (graduationYearValues.includes(graduationYear)) {
            graduationYearSelect.tomselect.setValue(graduationYear);
          } else {
            graduationYearSelect.tomselect.setValue(graduationYearValues[0]);
          }
        } else {
          graduationYearSelect?.tomselect.clear();
        }

        // set mark and model
        if (customsMark && setModels) {
          document
            .getElementById('customsMark')
            .tomselect.setValue(customsMark);
          setModels();
          if (customsModel) {
            const tomSelectElement =
              document.getElementById('customsModel').tomselect;
            const model = customsModel.toLowerCase();
            if (model.includes('series')) {
              tomSelectElement.setValue(model.replace(' ', '-'));
            } else {
              tomSelectElement.setValue(customsModel);
            }
          }
        } else {
          document.getElementById('customsMark')?.tomselect.clear();
          document.getElementById('customsModel')?.tomselect.clear();
        }

        if (onChangeCalcType) {
          onChangeCalcType();
        }

        const emptyInputs = [
          ...(document
            .getElementById('calc-inputs')
            ?.querySelectorAll('.input') || []),
        ].filter((el) => {
          const target = document.getElementById(el.dataset.param);
          return target && !target.value;
        });

        emptyInputs.forEach((el) => {
          el.classList.add('animated', 'shakeX');

          const handleAnimationEnd = () => {
            el.classList.remove('animated', 'shakeX');
            el.removeEventListener('animationend', handleAnimationEnd); // видаляємо слухач
          };

          el.addEventListener('animationend', handleAnimationEnd);
        });
      },
      onError: ({ message }) => {
        const errorElement = document.getElementById('getLotInfoError');
        errorElement.innerHTML = message;
        errorElement.classList.remove('hidden');
      },
    });
  });
}
